export default {
  en: {
    'mark_all_as_read': 'mark all as read',
    'notifications': 'notifications',
    'no_notifications': 'no notifications',
    'no_unread_notifications': 'no unread notifications',
    'show_all_notifications': 'show all notifications',
    'delete_all': 'delete all',
    '': '',
  }
};